"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var avatarUtils_1 = require("../../../utils/components/primitives/avatarUtils");
var StyledAvatar = (0, styled_components_1.default)("img")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  object-fit: cover;\n"], ["\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  object-fit: cover;\n"])), function (props) { return (0, avatarUtils_1.setAvatarBySize)(props.size); }, function (props) { return (0, avatarUtils_1.setAvatarBySize)(props.size); });
var Avatar = function (props) {
    var size = props.size, _a = props.className, className = _a === void 0 ? "" : _a;
    return ((0, jsx_runtime_1.jsx)(StyledAvatar, __assign({}, props, { size: size, className: "wellms-component ".concat(className) })));
};
exports.Avatar = Avatar;
var NewAvatar = (0, styled_components_1.default)(exports.Avatar)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.default = (0, styled_components_1.withTheme)(NewAvatar);
var templateObject_1, templateObject_2;
